<script>
import { mixins, Radar } from "vue-chartjs";
import "chart.js-plugin-labels-dv";

const { reactiveProp } = mixins;

import AnalysisTooltip from "./analysis_tooltip.js";

export default {
	name: "radar-chart",
	extends: Radar,
	mixins: [reactiveProp],
	props: {
		showLabels: Boolean,
		chartId: String,
		srvPhaseId: Number,
		perspectiveActorId: Number,
		propertyTypeKeyPart: String,
		apValueColumn: String,
	},
	computed: {
		chartOptions() {
			const analyisTooltip = _.cloneDeep(AnalysisTooltip); // Clone object
			// Overwrite default
			analyisTooltip.callbacks.label = (datasetForIndex) => {
				const dataForItem =
					datasetForIndex.dataset.data[datasetForIndex.dataIndex];
				return `${datasetForIndex.dataset.labelsPerItem ? datasetForIndex.dataset.labelsPerItem[datasetForIndex.dataIndex] : datasetForIndex.labels[datasetForIndex.dataIndex]}: ${dataForItem}`;
			};

			return {
				scales: {
					r: {
						// 'r' is the radial scale for radar charts
						beginAtZero: true,
						min: 0,
						// max: this.currentMaxOverAll
						max: this.maxOfCurrentActor,
					},
				},
				plugins: {
					legend: {
						display: false,
					},
					tooltip: analyisTooltip,
				},
				elements: {
					line: {
						borderWidth: 3,
					},
				},
			};
		},
		phaseId() {
			return this.srvPhaseId !== undefined
				? this.srvPhaseId
				: pp.gameState.phaseId;
		},
		bgColors() {
			const perspectiveActorColorClass = VueStore.getters.actorData(
				this.perspectiveActorId,
			)
				? VueStore.getters.actorData(this.perspectiveActorId).color
				: "bg-theme-light";
			const perspectiveActorColor = pp.viewHelpers.detectCssRuleFor(
				`.${perspectiveActorColorClass}`,
				"background-color",
			);
			const secondColor = pp.viewHelpers.detectCssRuleFor(
				".bg-theme-dark",
				"background-color",
			);
			// Add opacity to the extracted colors
			return [
				`${perspectiveActorColor.slice(0, perspectiveActorColor.length - 1)}, 0.3${perspectiveActorColor.slice(perspectiveActorColor.length - 1)}`,
				`${secondColor.slice(0, secondColor.length - 1)}, 0.3${secondColor.slice(secondColor.length - 1)}`,
			];
		},
		// currentMaxOverAll() {
		// 	const collectedValuesForPropertyTypeKey = Object.keys(VueStore.getters.gameActors()).map(actorId => {
		// 		const apsForActor = VueStore.getters.actorsPropertiesFor(actorId);
		// 		if (!apsForActor) {
		// 			return [];
		// 		}
		// 		return apsForActor.filter(ap => ap.property.type_key.indexOf(this.propertyTypeKeyPart) == 0).map((ap) => {
		// 			pp.log("at ap", ap.property.names[I18n.locale]);
		// 			return ap.values[this.phaseId].current_value
		// 		})
		// 	}).flat()
		// 	pp.log("coll", collectedValuesForPropertyTypeKey);
		// 	return Math.max(...collectedValuesForPropertyTypeKey); // Parameterize
		// },
		perspectiveAndMirrorActorsProperties() {
			const perspectiveActor = VueStore.getters.actorData(
				this.perspectiveActorId,
			);
			const perspectiveActorCountryCode =
				perspectiveActor.acronyms[I18n.locale];
			const perspectiveActorsProperties = VueStore.getters
				.actorsPropertiesFor(this.perspectiveActorId)
				.filter((actorProperty) => {
					return (
						actorProperty.property.type_key.indexOf(this.propertyTypeKeyPart) ==
						0
					);
				});
			const mirrorActorsProperties = [];
			const perspectiveIndicesToRemove = [];
			perspectiveActorsProperties.forEach((actorProperty, index) => {
				// pp.log("looking at", actorProperty, Object.values(actorProperty.property.names)[0], index);
				// Cut the 'duties_' or 'dependence_' bit from the type key
				const mirrorCountryCodeFromTypeKey =
					actorProperty.property.type_key.slice(
						// @ts-expect-error
						this.propertyTypeKeyPart.length + 1,
					);
				const mirrorActor = VueStore.getters.actorWithAcronym(
					mirrorCountryCodeFromTypeKey,
					I18n.locale,
				);
				if (!mirrorActor) {
					// pp.log("- not found");
					// perspectiveActorsProperties.splice(index, 1);
					// Can't add to the `mirrorActorsProperties` if not found;
					// Need to remove from the `perspectiveActorsProperties` hash too, but can't do it in this loop, so store for the loop below
					perspectiveIndicesToRemove.push(index);
					return;
				}
				VueStore.getters
					.actorsPropertiesFor(mirrorActor.id)
					.forEach((actorProperty) => {
						if (
							actorProperty.property.type_key.indexOf(
								`${this.propertyTypeKeyPart}_${perspectiveActorCountryCode}`,
							) == 0
						) {
							mirrorActorsProperties.push(actorProperty);
						}
					});
			});
			perspectiveIndicesToRemove.forEach((position) => {
				perspectiveActorsProperties.splice(position, 1);
			});
			return {
				perspectiveActorsProperties: perspectiveActorsProperties,
				mirrorActorsProperties: mirrorActorsProperties,
			};
		},
		chartData() {
			const perspectiveAndMirrorActorsProperties =
				this.perspectiveAndMirrorActorsProperties;
			return {
				labels: perspectiveAndMirrorActorsProperties.mirrorActorsProperties.map(
					(ap) => VueStore.getters.actorData(ap.actor_id).names[I18n.locale],
				),
				datasets: Object.values(perspectiveAndMirrorActorsProperties).map(
					(apsSet, index) => {
						return {
							data: apsSet.map(
								// @ts-expect-error
								(ap) => ap.values[this.phaseId][this.apValueColumn],
							),
							labelsPerItem: apsSet.map((ap) => ap.property.names[I18n.locale]),
							fill: true,
							backgroundColor: this.bgColors[index],
						};
					},
				),
			};
		},
	},
	methods: {
		maxOfCurrentActor() {
			const perspectiveAndMirrorActorsProperties =
				this.perspectiveAndMirrorActorsProperties;
			const collectedValuesForPropertyTypeKey = Object.values(
				perspectiveAndMirrorActorsProperties,
			)
				.map((apsForActor) => {
					return apsForActor
						.map((ap) => {
							return Object.values(ap.values).map(
								(valuePairForPhase) => valuePairForPhase.current_value,
							);
						})
						.flat();
				})
				.flat();
			return Math.max(...collectedValuesForPropertyTypeKey); // Parameterize
		},
	},
	mounted() {
		// pp.log("mounted", this.chartId);
		// @ts-expect-error
		this.renderChart(this.chartData, this.chartOptions);

		pp.vue.bus.$on("CHART-datasets_changed", (data) => {
			if (data.chartId == this.chartId) {
				// pp.log("updating", this.chartId, data);
				if (data.perspectiveActorId) {
					// @ts-expect-error
					this.perspectiveActorId = parseInt(data.perspectiveActorId, 10);
				}
				if (data.phaseId) {
					// @ts-expect-error
					this.srvPhaseId = parseInt(data.phaseId, 10);
				}
			}
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("CHART-datasets_changed");
	},
};
</script>
